var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jawg-map" }, [
    _c("div", {
      ref: "mapContainer",
      staticStyle: { width: "100%", height: "100%" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }